// Mirrors the derived primary palette into CSS custom properties, so Tailwind's `primary-*`
// classes (rgb(var(--color-primary-XXX) / <alpha-value>) in tailwind.config.js) stay in sync
// with MUI's theme.palette.primary — both read from the exact same buildPrimaryPalette output.
import { decomposeColor } from '@mui/material/styles'
import { PrimaryPalette } from './buildPrimaryPalette'

// Tailwind's `rgb(var(--x) / <alpha-value>)` pattern expects a space-separated "R G B"
// triplet (not a hex string or "rgb(...)" wrapper) so alpha modifiers like `bg-primary-500/50` work.
const toRgbTriplet = (hex: string): string => decomposeColor(hex).values.slice(0, 3).join(' ')

export const applyPrimaryCssVariables = (palette: PrimaryPalette, root: HTMLElement = document.documentElement): void => {
  ;(Object.keys(palette.tones) as unknown as Array<keyof PrimaryPalette['tones']>).forEach((step) => {
    root.style.setProperty(`--color-primary-${step}`, toRgbTriplet(palette.tones[step]))
  })
  root.style.setProperty('--color-primary-contrast', toRgbTriplet(palette.contrastText))
}
